import { css } from "@mds/core";

export const navigationLinkCSS = css`
	@supports (--foo: "mds") {
		/* 	###################################################################### */
		/**	Component tokens
			   Use the design tokens to set these component tokens.
		   */
		:host {
			--display: inline-block;
			--pad-start: 0;
			--pad-end: 0;
			--line-weight-vertical: 0;
			--active-color-start: transparent;
			--color: var(--mds-color-text-link);
			--link-weight: var(--mds-typography-font-gui-weight-light, normal);
			--font-family: var(--mds-typography-font-gui-fonts);
			--line-height: calc(
				(var(--mds-typography-scale-height-xxl) * 2) - 0.25
			);
		}

		/* 	###################################################################### */
		/**	Properties for navigation */
		:host {
			display: var(--display, inline-block);
			box-sizing: border-box;
			border-radius: var(--mds-line-border-base-radius);
		}

		a,
		a:link,
		a:active,
		a:visited,
		a:focus-visible,
		a:hover {
			display: var(--display, inline-block);
			text-decoration: none;
			color: var(--color);
			padding-inline-start: var(--pad-start, 0);
			padding-inline-end: var(--pad-end, 0);
			border-bottom: var(--line-weight-horzontal, 2px) solid
				var(--active-color-bottom, transparent);
			border-inline-start: var(--line-weight-vertical, 0) solid
				var(--active-color-start, transparent);
			border-radius: var(--mds-line-border-base-radius);
			font-family: var(--font-family);
			font-weight: var(--link-weight);
			line-height: var(--line-height);
			cursor: pointer;
		}

		a:hover {
			--color: var(--mds-color-text-link-hover);
		}

		[active] {
			--link-weight: var(--mds-typography-font-gui-weight-bold);
			--active-color-start: transparent;
			--active-color-bottom: var(--mds-color-border-link);
		}

		/* 	###################################################################### */
		/**	Rules for icons */
		:host([icon]) a::before {
			font-family: var(--mds-icon-font-base-family);
			content: var(--icon-glyph);
			padding-inline-end: var(--mds-spacing-2);
			line-height: 2.8;
		}
		:host([issubmenulink]) a {
			box-sizing: border-box;
			display: block;
			padding-inline-start: var(--mds-spacing-4);
			padding-inline-end: var(--mds-spacing-4);
			--link-weight: var(--mds-typography-font-gui-weight-normal);
			--line-weight-horzontal: 1px;
			--line-weight-vertical: 4px;
			--active-color-start: transparent;
			--active-color-bottom: transparent;
			border-bottom: 0;
			white-space: normal;
			word-wrap: break-word;
			width: 95%;
			line-height: var(--mds-typography-scale-height-l);
			padding-block-start: var(--mds-spacing-3);
			padding-block-end: var(--mds-spacing-3);
		}
		:host([issubmenulink]) a[active] {
			--link-weight: var(--mds-typography-font-gui-weight-bold);
		}
		:host([hasdropdown]) a::after {
			font-family: var(--mds-icon-font-base-family);
			content: var(--mds-icon-glyphs-base-arrow-down-angle);
			padding-inline-start: var(--mds-spacing-1);
			line-height: 2.8;
			font-weight: normal;
		}
		:host([hasdropdown][toggled]) a::after {
			content: var(--mds-icon-glyphs-base-arrow-top-angle);
		}
		:host([hasdropdown][break]) a::after {
			float: right;
			padding-inline-end: calc(
				var(--pad-responsive) + var(--mds-spacing-3)
			);
		}
		:host([break]) {
			display: block;
			--pad-start: var(--pad-responsive, var(--mds-spacing-2));
			--line-weight-horzontal: 1px;
			--line-weight-vertical: 4px;
		}

		:host([break]:not([icon])) a {
			display: block;
		}
		:host([issubmenulink]) a {
			width: 100%;
		}
		:host([issubmenulink]) a:hover {
			background-color: var(--mds-color-background-neutral-subtle-hover);
		}
		:host([issubmenulink][break]) a {
			text-align: start;
		}
		:host([issubmenulink]) a[active],
		:host([break]) [active] {
			--active-color-start: var(--mds-color-background-cta);
			--active-color-bottom: var(--mds-color-background-pale);
		}
		:host([break][icon]) a {
			position: relative;
		}
		:host([break][icon][hasdropdown]) a::after {
			font-family: var(--mds-icon-font-base-family);
			content: "";
			position: absolute;
			padding: 0;
			bottom: calc(var(--mds-typography-scale-height-s) * -1rem);
			left: clamp(
				var(--mds-spacing-1),
				var(--pad-responsive, var(--gap)),
				var(--mds-spacing-4)
			);
			width: 1rem;
			height: 1rem;
			background: white;
			transform: rotate(45deg);
			opacity: 0;
			transition: opacity 0.2s step-start;
		}
		:host([break][icon][hasdropdown][toggled]) a::after {
			opacity: 1;
			transition: opacity 0.2s step-end;
		}
		:host([break][icon]) {
			display: inline-block;
			width: auto;
		}

		:host([break][icon]) a {
			border: 0;
			padding: 0
				clamp(
					var(--mds-spacing-2),
					var(--pad-responsive),
					var(--mds-spacing-4)
				);
		}
		:host([issubmenulink][break]:not([icon])) a {
			border: 0;
			background-color: transparent;
		}
		:host([break][icon]) a::after {
			content: none;
		}
		:host([break][icon]) span {
			position: absolute;
			top: -100vh;
			z-index: -100;
		}
	}
`;
